import React from 'react';
import { Card } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import LogsTable from '../../components/LogsTable';
import ActivityWorkspace from './ActivityWorkspace';

const Log = () => {
  const { t } = useTranslation();

  if (localStorage.getItem('platform_currency') === 'CNY')
    return <ActivityWorkspace />;
  return (
    <div className='dashboard-container'>
      <Card fluid className='chart-card'>
        <Card.Content>
          <Card.Header className='header'>{t('log.title')}</Card.Header>
          <LogsTable />
        </Card.Content>
      </Card>
    </div>
  );
};

export default Log;
